import { InputGroup } from '@blueprintjs/core'
import Slider from 'rc-slider'
import React from 'react'
import { useUser } from '../../hooks/useUser'
import { Tooltip } from '../../components/ui/tooltip'
import { Button } from '../../components/ui/button'

interface AdSpendSliderProps {
    value: number
    onChange: (value: number) => void
    disabled: boolean
    loading: boolean
    onAdSpendRefresh: () => void
}

export const AdSpendSlider = ({
    value,
    onChange,
    disabled,
    loading,
    onAdSpendRefresh,
}: AdSpendSliderProps) => {
    const { user } = useUser()
    const hasManagedProfiles = user?.keys?.profiles?.reduce(
        (prev, curr) => prev || curr.managed,
        false,
    )

    const adSpendToSlider = (v: number): number => {
        return Math.log(v)
    }

    const sliderToAdSpend = (v: number): number => {
        return Math.round(Math.exp(v))
    }

    return (
        <div>
            Your Monthly Ad Spend
            <div className="mb-2 flex justify-center">
                <InputGroup
                    fill={false}
                    disabled={disabled}
                    style={{ width: '200px' }}
                    leftIcon={<Button style={{ zIndex: 1 }} minimal text="$" />}
                    rightElement={
                        hasManagedProfiles ? (
                            <Tooltip
                                content={
                                    <div style={{ maxWidth: '300px' }}>
                                        Load your actual ad spend for the past 30 days across all
                                        managed profiles
                                    </div>
                                }
                            >
                                <Button
                                    style={{ zIndex: 1 }}
                                    minimal
                                    loading={loading}
                                    onClick={() => onAdSpendRefresh()}
                                    text="&#x21bb;"
                                />
                            </Tooltip>
                        ) : undefined
                    }
                    value={'' + value}
                    onChange={(e) => onChange(parseFloat(e.target.value || '0'))}
                />
            </div>
            <Slider
                disabled={disabled}
                value={adSpendToSlider(value)}
                onChange={(v) => onChange(sliderToAdSpend(v))}
                min={Math.log(500)}
                max={Math.log(100000)}
                step={0.01}
                marks={{
                    [Math.log(500)]: '$500',
                    [Math.log(1000)]: '$1,000',
                    [Math.log(3000)]: '$3,000',
                    [Math.log(50000)]: '$5,000',
                    [Math.log(10000)]: '$10,000',
                    [Math.log(25000)]: '$25,000',
                    [Math.log(50000)]: '$50,000',
                    [Math.log(100000)]: '$100,000',
                }}
            />
        </div>
    )
}
